import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {AuthHelperService} from '../helpers/auth-helper.service';

export const sessionBasedAuthInterceptor: HttpInterceptorFn = (request, next) => {
    const signingPageToken = inject(AuthHelperService).getLocalDevToken();

    if (signingPageToken) { //TODO: temporary fix while BE will allow to connect from localhost
        return next(request.clone({
            setHeaders: {
                'Authorization': `Bearer ${signingPageToken}`
            },
            withCredentials:false,
        }));
    } else {
        return next(request.clone({
            withCredentials:true,
        }));
    }

};
